import styled from 'styled-components';

const Container = styled.div`
  > div > div:first-child {
    flex-direction: ${(p) => (p.isCardInput ? 'column' : 'row')};
    box-sizing: border-box;
    height: ${(p) => (p.isCardInput ? 140 : 60)}px;
    width: ${(p) => (p.isCardInput ? '240px' : 'auto')};
    padding: 0;
    background-color: ${(p) =>
      p.isCardInput ? p.theme.color.backgroundRush : p.theme.color.background};
    border: ${(p) => (p.isCardInput ? '2px solid' : 'none')};
    border-color: ${(p) => p.theme.color.background};
    box-shadow: none;
    border-radius: 15px;
    overflow: hidden;
  }
`;

const CardInputRow = styled.div`
  margin: ${(p) => (p.isCardInput ? '10px 0 0 0' : '10px')};
  width: ${(p) => (p.isCardInput ? '100%' : 'auto')};
  box-sizing: border-box;
  padding: ${(p) => (p.isCardInput ? '0 20px' : '0')};
  display: flex;
  flex-direction: row;
  &:last-child {
    margin: ${(p) => (p.isCardInput ? 'auto 0 15px 0' : '10px')};
  }

  button {
    margin-left: auto;
  }
`;

const CardImage = styled.svg`
  width: 42px !important;
  height: 25px !important;
  margin: ${(p) => (p.isCardInput ? 0 : 15)}px;
`;

const CardNumberInput = styled.input`
  background-color: ${(p) => p.theme.color.background};
  height: 30px;
  width: ${(p) => (p.isCardInput ? '100%' : '11em')} !important;
  padding: ${(p) => (p.isCardInput ? '5px 10px' : 0)} !important;
  padding-right: 15px !important;
  color: ${(props) => props.theme.color.mainFont} !important;
  font-size: ${(p) => (p.isCardInput ? 12 : 14)}px !important;
  border-radius: ${(p) => (p.isCardInput ? 10 : 0)}px;
  box-sizing: ${(p) => (p.isCardInput ? 'border-box' : 'unset')};
  &::placeholder {
    color: ${(p) =>
      p.isCardInput ? p.theme.color.mainFont : p.theme.color.gray};
    text-transform: uppercase;
    font-size: 14px;
  }
`;

const CardExpiryCvcInput = styled.input`
  height: ${(p) => (p.isCardInput ? '30px' : '100%')};
  padding: ${(p) => (p.isCardInput ? '5px 10px' : '0 20px')} !important;
  padding-right: 15px !important;
  color: ${(props) => props.theme.color.mainFont} !important;
  font-size: ${(p) => (p.isCardInput ? 12 : 14)}px !important;
  box-sizing: ${(p) => (p.isCardInput ? 'border-box' : 'unset')};
  text-align: ${(p) => (p.isCardInput ? 'left' : 'center')};
  margin: 0 !important;
  border-left: 1px solid ${(p) => p.theme.color.backgroundRush} !important;
  background-color: ${(p) => p.theme.color.background};
  &::placeholder {
    color: ${(p) =>
      p.isCardInput ? p.theme.color.mainFont : p.theme.color.gray};
    text-transform: uppercase;
    font-size: 14px;
  }
  &:first-child {
    width: ${(p) => (p.isCardInput ? '65%' : '4em')} !important;
    border-radius: ${(p) => (p.isCardInput ? '10px 0 0 10px' : 0)};
  }
  &:last-child {
    width: ${(p) => (p.isCardInput ? '35%' : '2.5em')} !important;
    border-radius: ${(p) => (p.isCardInput ? '0 10px 10px 0' : 0)};
  }
`;

const CardInputButton = styled.div`
  width: 60px;
  height: 60px;
  line-height: 60px;
  background-color: ${(p) =>
    p.isValid ? p.theme.color.green : p.theme.color.turquoise};
  font-size: 14px;
  text-align: center;
  color: ${(props) => props.theme.color.mainFont};
  cursor: ${(p) => (p.isValid ? 'pointer' : 'default')};
  pointer-events: ${(p) => (p.isValid ? 'auto' : 'none')};
`;

export const Styled = {
  Container,
  CardInputRow,
  CardImage,
  CardNumberInput,
  CardExpiryCvcInput,
  CardInputButton,
};
